<template>
  <div>
    <el-dialog
      title="用户选择框"
      :visible.sync="userVisible"
      width="60%"
      :before-close="cancel"
    >
      <div class="approver-wrap" v-loading="loading">
        <div class="user-container">
          <div class="tab-title-list">
            <div class="list">
              <span
                v-for="(item, index) in tabTitleList"
                :key="index"
                @click="handleClick(item)"
                :class="[tabName === item.name ? 'tabActive' : '']"
                >{{ item.value }}</span
              >
            </div>
            <div class="search-box">
              <el-input
                placeholder="按用户名称或账号搜索"
                v-model="searchValue"
                @keyup.enter.native="handleIconSearch(searchValue)"
                size="small"
              >
                <el-button
                  @click="handleIconSearch(searchValue)"
                  slot="append"
                  icon="el-icon-search"
                ></el-button>
              </el-input>
            </div>
          </div>
          <div class="tab-container">
            <!--按部门-->
            <div
              class="tab-container-box"
              :class="[tabName === 'dept' ? 'tabBoxBlock' : 'tabBoxNone']"
            >
              <div class="contact user-common">
                <!--左-->
                <div class="left">
                  <span class="top-title">部门列表：</span>
                  <el-scrollbar class="scrollbar">
                    <div class="dept-tree">
                      <el-tree
                        :props="deptProps"
                        :load="loadNode"
                        node-key="id"
                        ref="deptTree"
                        lazy
                        :expand-on-click-node="false"
                        :check-strictly="true"
                        :default-expanded-keys="defaultExpandedKeys"
                        @node-click="handleNodeClick($event)"
                      ></el-tree>
                    </div>
                  </el-scrollbar>
                </div>
                <!--中-->
                <div class="role-page">
                  <div class="user-list">
                    <div class="add-all-data">
                      <span @click="addAllPage('DEPT')">添加本页所有</span>
                    </div>
                    <div class="current-role" v-if="currentDeptName">
                      角色：管理员
                    </div>
                    <el-scrollbar class="scrollbar">
                      <div class="list-box">
                        <!--单选-->
                        <!--<el-radio-group v-model="selectedUserFree">
                          <el-radio style="display:block;" v-for="user in searchData && searchData.length > 0 ? searchData : deptUser" :label="user.id" :key="user.id" @change="handleRadioChange($event, user, user.id)">{{
                            user.name
                          }}</el-radio>
                        </el-radio-group>-->
                        <!--复选-->
                        <el-checkbox-group v-model="selectedUsers">
                          <el-checkbox
                            style="display: block"
                            v-for="user in searchData && searchData.length > 0
                              ? searchData
                              : deptUser"
                            :label="user.id"
                            :key="user.id"
                            @change="handleSelectChange($event, user, user.id)"
                            >{{ user.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div
                        class="no-data"
                        style="padding-left: 10px"
                        v-if="searchData.length <= 0 && rolesData.length <= 0"
                      >
                        <span v-if="isclickEmpty"> 找不到用户 </span>
                      </div>
                    </el-scrollbar>
                  </div>
                  <div class="btn" v-if="row_count > 10">
                    <el-pagination
                      small
                      :pager-count="5"
                      :current-page.sync="currentPage"
                      :page-size="10"
                      layout="prev, pager, next"
                      :total="row_count"
                      @current-change="deptLoadingMore($event)"
                    ></el-pagination>
                  </div>
                </div>
                <!--右-->
                <div class="selected-role">
                  <div class="add-all-data">
                    <div>已选择用户：</div>
                    <div>
                      <span @click="removeAll">移除</span>
                    </div>
                  </div>
                  <el-scrollbar class="scrollbar">
                    <div class="tag-lists">
                      <el-tag
                        class="tag"
                        v-for="(user, i) in selectedUsersList"
                        :key="user.name"
                        @close="closableTag(user.id, i)"
                        closable
                        >{{ user.name }}</el-tag
                      >
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </div>

            <!--按角色-->
            <div
              class="tab-container-box"
              :class="[tabName === 'role' ? 'tabBoxBlock' : 'tabBoxNone']"
            >
              <div class="role user-common">
                <!--左-->
                <span class="role-left">
                  <span class="top-title">角色列表:</span>
                  <el-scrollbar class="scrollbar">
                    <ul>
                      <li
                        v-for="item in allRoles"
                        :key="item.id"
                        @click="rolesList(item.id, item.name)"
                      >
                        <!-- <img src="../assets/images/right_2.gif" class="icon-img" v-if="item.id == roleCurrentId" /> -->
                        {{ item.name }}
                      </li>
                    </ul>
                  </el-scrollbar>
                </span>
                <!--中-->
                <div class="role-page">
                  <div class="user-list">
                    <div class="add-all-data">
                      <span @click="addAllPage('ROLE')">添加本页所有</span>
                    </div>
                    <div class="current-role">角色：{{ currentRoleName }}</div>
                    <el-scrollbar class="scrollbar">
                      <div class="list-box">
                        <!-- <el-radio-group v-model="selectedUserFree">
                          <el-radio
                            style="display:block;"
                            v-for="user in searchData && searchData.length > 0 ? searchData : rolesData"
                            :label="user.id"
                            :key="user.id"
                            @change="handleRadioChange($event, user, user.id)"
                            >{{ user.name }}</el-radio
                          >
                        </el-radio-group>-->
                        <!--复选-->
                        <el-checkbox-group v-model="selectedUsers">
                          <el-checkbox
                            style="display: block"
                            v-for="user in searchData && searchData.length > 0
                              ? searchData
                              : rolesData"
                            :label="user.id"
                            :key="user.id"
                            @change="handleSelectChange($event, user, user.id)"
                            >{{ user.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div
                        class="no-data"
                        style="padding-left: 10px"
                        v-if="searchData.length <= 0 && rolesData.length <= 0"
                      >
                        <span v-if="isclickEmpty"> 找不到用户 </span>
                      </div>
                    </el-scrollbar>
                  </div>
                  <div class="btn">
                    <el-pagination
                      small
                      :pager-count="5"
                      :current-page.sync="currentPage"
                      :page-size="10"
                      layout="prev, pager, next"
                      :total="row_count"
                      @current-change="rolesLoadingMore($event)"
                    ></el-pagination>
                  </div>
                </div>
                <!--右-->
                <div class="selected-role">
                  <div class="add-all-data">
                    <div>已选择用户：</div>
                    <div>
                      <span @click="removeAll">移除</span>
                    </div>
                  </div>
                  <el-scrollbar class="scrollbar">
                    <div class="tag-lists">
                      <el-tag
                        class="tag"
                        v-for="(user, i) in selectedUsersList"
                        :key="i"
                        @close="closableTag(user.id, i)"
                        closable
                        >{{ user.name }}</el-tag
                      >
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </div>

            <!--通讯录-->
            <div
              class="tab-container-box"
              :class="[tabName === 'tel' ? 'tabBoxBlock' : 'tabBoxNone']"
            >
              <div class="contact user-common">
                <!--左-->
                <div class="left">
                  <span class="top-title">通讯录：</span>
                  <span @click="contact" class="all-contact">
                    <!-- <img src="../assets/images/right_2.gif" class="icon-img" /> -->
                    全部联系人
                  </span>
                </div>
                <!--中-->
                <div class="role-page">
                  <div class="user-list">
                    <div class="add-all-data">
                      <span @click="addAllPage('ADDRESSBOOK')"
                        >添加本页所有</span
                      >
                    </div>
                    <div class="current-role">角色：联系人</div>
                    <el-scrollbar class="scrollbar">
                      <div class="list-box">
                        <!--单选-->
                        <!-- <el-radio-group v-model="selectedUserFree">
                          <el-radio style="display:block;" v-for="user in linkman" :label="user.id" :key="user.id" @change="handleRadioChange($event, user, user.id)">{{ user.name }}</el-radio>
                        </el-radio-group> -->
                        <!--复选-->
                        <el-checkbox-group v-model="selectedUsers">
                          <el-checkbox
                            style="display: block"
                            v-for="user in linkman"
                            :label="user.id"
                            :key="user.id"
                            @change="handleSelectChange($event, user, user.id)"
                            >{{ user.name }}</el-checkbox
                          >
                        </el-checkbox-group>
                      </div>
                      <div
                        class="no-data"
                        style="padding-left: 10px"
                        v-if="searchData.length <= 0 && rolesData.length <= 0"
                      >
                        <span v-if="isclickEmpty"> 找不到用户 </span>
                      </div>
                    </el-scrollbar>
                  </div>
                  <div class="btn">
                    <el-pagination
                      small
                      :pager-count="5"
                      :current-page.sync="currentPage"
                      :page-size="10"
                      layout="prev, pager, next"
                      :total="row_count"
                      @current-change="contactLoadingMore($event)"
                    ></el-pagination>
                  </div>
                </div>
                <!-- 右 -->
                <div class="selected-role">
                  <div class="add-all-data">
                    <div>已选择用户：</div>
                    <div>
                      <span @click="removeAll">移除</span>
                    </div>
                  </div>
                  <el-scrollbar class="scrollbar">
                    <div class="tag-lists">
                      <el-tag
                        class="tag"
                        v-for="(user, i) in selectedUsersList"
                        :key="i"
                        @close="closableTag(user.id, i)"
                        closable
                        >{{ user.name }}</el-tag
                      >
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </div>

            <!--最近-->
            <div
              class="tab-container-box"
              :class="[tabName === 'recent' ? 'tabBoxBlock' : 'tabBoxNone']"
            >
              <div class="recent-box">
                <div class="left">
                  <span class="top-title">最近添加的用户：</span>
                  <el-scrollbar class="scrollbar">
                    <div class="list-box">
                      <!--单选-->
                      <!-- <el-radio-group v-model="selectedUserFree">
                        <el-radio
                          style="display:block;"
                          v-for="user in searchData && searchData.length > 0 ? searchData : recentUsers"
                          :label="user.id"
                          :key="user.id"
                          @change="handleRadioChange($event, user, user.id)"
                          >{{ user.name }}</el-radio
                        >
                      </el-radio-group> -->

                      <!--复选-->
                      <el-checkbox-group v-model="selectedUsers">
                        <el-checkbox
                          style="display: block"
                          v-for="user in searchData && searchData.length > 0
                            ? searchData
                            : recentUsers"
                          :label="user.id"
                          :key="user.id"
                          @change="handleSelectChange($event, user, user.id)"
                          >{{ user.name }}</el-checkbox
                        >
                      </el-checkbox-group>
                    </div>
                  </el-scrollbar>
                </div>
                <div class="center">
                  <i class="el-icon-arrow-right"></i>
                </div>
                <div class="right">
                  <div class="add-all-data">
                    <div>已选择用户：</div>
                    <div>
                      <!-- <el-button type="danger" size="small" @click="closeAll">移除所有</el-button> -->
                      <span @click="removeAll">移除</span>
                    </div>
                  </div>
                  <el-scrollbar class="scrollbar">
                    <div class="tag-lists">
                      <el-tag
                        class="tag"
                        v-for="(user, i) in selectedUsersList"
                        :key="i"
                        @close="closableTag(user.id, i)"
                        closable
                        >{{ user.name }}</el-tag
                      >
                    </div>
                  </el-scrollbar>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="dialog-footer" slot="footer">
          <el-button plain @click="cancel" size="small">取 消</el-button>
          <el-button type="primary" @click="onOk" size="small">确 定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'user_select',
  data() {
    return {
      loading: true,
      searchValue: '', // 搜索
      searchData: [], //搜索返回的数据

      // 共用
      selectedUserFree: '', // 选中的角色id(单选)
      selectedUsers: [], // 中间选中的角色id(复选)
      currentPage: 1, // 当前的页码值
      row_count: 0, // 总条数
      selectedUsersList: [], //已选中的角色数据列表

      // 部门
      deptProps: {
        // tree的配置项
        label: 'name',
        children: 'zones',
        isLeaf: 'leaf',
      },
      deptUser: [], //部门员工列表
      currentDeptName: '', // 当前选中部门列表的名称
      departId: '', // 点击的部门id
      deptCount: 0, // 显示的总数
      title: '', //

      // 角色
      allRoles: [], //左侧所有角色
      rolesData: [], //中间角色数据
      currentRoleName: '', // 当前用户的角色名称
      roleCurrentId: '', // 当前选中的角色id

      // 通讯录
      linkman: [], //通讯录联系人
      // 最近联系人
      recentUsers: [], // 最近联系人

      defaultExpandedKeys: [], // 默认展开的数组

      tabName: 'dept',
      tabTitleList: [
        // 选项卡名称
        {
          name: 'dept',
          value: '按部门',
        },
        {
          name: 'role',
          value: '按角色',
        },
        {
          name: 'tel',
          value: '通讯录',
        },
        {
          name: 'recent',
          value: '最近',
        },
      ],

      deptId: '', // 左侧树的部门id

      isclickEmpty: false, // 是否显示找不到联系人的文字
    }
  },
  components: {},
  created() {
    this.selectedUsersList = this.rightSelectedUser
    this.loading = false
  },
  methods: {
    /**
     * 弹窗关闭
     */
    cancel() {
      this.$emit('closeUserVisiable')
    },

    /**
     * 查询
     */
    handleIconSearch(value) {
      let params = {
        pageNum: 1,
        pageSize: 10,
      }
      this.loading = true
      this.$api.searchUser(value, params, {
        onSucess: (res) => {
          this.loading = false
          this.rolesData = []
          this.deptUser = []
          this.linkman = []
          if (res.data.data.msg) {
            this.isclickEmpty = true
            this.searchData = []
            this.row_count = 0
          } else {
            this.searchData = res.data.data.datas
            this.row_count = res.data.data.rowCount
          }
        },
        onError:(res) => {
          console.log(res)
        }
      })
    },

    /**
     * 点击标签页
     */
    handleClick(tab) {
      this.isclickEmpty = false
      this.tabName = tab.name
      let appId = 'sOZu9kthmxyP8qQfq0e'
      this.loading = true
      if (tab.name == 'role') {
        let params = {
          roleId: '',
          pageSize: 10,
          pageNum: 1,
          type: 0,
        }
        this.$api.getRoleUser(appId, params, {
          onSucess: (response) => {
            this.loading = false
            if (response.data.errcode == 0) {
              this.allRoles = response.data.data.datas
            }
          },
        })
      } else if (tab.name == 'recent') {
        this.recentUsers = JSON.parse(
          localStorage.getItem('localRecentUsers') || '[]'
        )
      }
    },

    /**
     * 确认
     */
    onOk() {
      this.$emit('selectedUsersList', this.selectedUsersList)
      this.$emit('closeUserVisiable')

      //以下都是最近用户缓存
      let selectList = JSON.parse(JSON.stringify(this.selectedUsersList))
      let recentUsers = JSON.parse(
        localStorage.getItem('localRecentUsers') || '[]'
      )
      let tempArray1 = [] //临时数组1
      let tempArray2 = [] //临时数组2
      if (recentUsers.length > 0) {
        for (let i = 0; i < recentUsers.length; i++) {
          tempArray1[recentUsers[i].id] = true
        }
      }
      for (let i = 0; i < selectList.length; i++) {
        if (tempArray1[selectList[i].id]) {
          selectList.splice(i, 1)
          i--
        }
      }
      let allLocalRecentUsers = selectList.concat(recentUsers)
      localStorage.setItem(
        'localRecentUsers',
        JSON.stringify(allLocalRecentUsers)
      ) //缓存最近的用户
    },

    // 部门
    /**
     * 点击部门树节点触发
     */
    handleNodeClick(e) {
      this.searchData = []
      this.deptId = e.id
      let appId = 'sOZu9kthmxyP8qQfq0e'
      const pageNum = 1
      const pageSize = 10
      this.loading = true
      this.$api.getDeptUser(appId, this.deptId, pageNum, pageSize, {
        onSucess: (response) => {
          this.loading = false
          let list = response.data.data.datas
          if (this.selectedUsers && this.selectedUsers.length > 0) {
            // 去重
            for (let i = 0; i < this.selectedUsers.length; i++) {
              for (let j = 0; j < list.length; j++) {
                if (this.selectedUsers[i] == list[j].id) {
                  list.splice(j, 1)
                  j--
                }
              }
            }
          }
          this.row_count = response.data.data.rowCount
          this.deptUser = list
          if (list.length <= 0) {
            this.isclickEmpty = true
          }
          this.title = e.name
          this.deptCount = response.data.data.rowCount
        },
      })
    },
    /**
     * 部门树 加载子树数据的方法，仅当 lazy 属性为true 时生效
     */
    loadNode(node, resolve) {
      if (node.level === 0) {
        this.$api.getDepartmentsByParentId(
          { applicationId: 'sOZu9kthmxyP8qQfq0e', parentId: '' },
          {
            onSucess: function (response) {
              // that.defaultExpandedKeys.push(response.data.data[0].id);
              resolve(response.data.data)
            },
          }
        )
      } else {
        this.$api.getDepartmentsByParentId(
          { applicationId: 'sOZu9kthmxyP8qQfq0e', parentId: node.key },
          {
            onSucess: function (response) {
              resolve(response.data.data)
            },
          }
        )
      }
    },

    // 角色
    /**
     * 角色分类加载
     */
    rolesList(id, name) {
      let appId = 'sOZu9kthmxyP8qQfq0e'
      let params = {
        roleId: id,
        pageSize: 10,
        pageNum: 1,
        type: 0,
      }
      this.loading = true
      this.$api.getRoleUser(appId, params, {
        onSucess: (response) => {
          this.loading = false
          if (response.data.errcode == 0) {
            this.rolesData = response.data.data.datas
          }
        },
      })
    },

    /**
     * 页码值改变
     */
    rolesLoadingMore(ev) {},

    // 共用
    /**
     * 添加本页所有的角色
     */
    addAllPage(val) {
      console.log(val)
      if (this.searchData && this.searchData.length > 0) {
        //当是搜索数据的时候
        if (this.selectedUsers && this.selectedUsers.length > 0) {
          this.searchData.forEach((item) => {
            if (arr.indexOf(item.id) < 0) {
              this.selectedUsersList.push(item)
              this.selectedUsers.push(item.id)
            }
          })
        } else {
          this.searchData.forEach((item) => {
            this.selectedUsersList.push(item)
            this.selectedUsers.push(item.id)
          })
        }
      } else {
        if (val == 'ROLE') {
          let arr = JSON.parse(JSON.stringify(this.selectedUsers))
          if (this.selectedUsers && this.selectedUsers.length > 0) {
            this.rolesData.forEach((item) => {
              if (arr.indexOf(item.id) < 0) {
                this.selectedUsersList.push(item)
                this.selectedUsers.push(item.id)
              }
            })
          } else {
            this.rolesData.forEach((item) => {
              this.selectedUsersList.push(item)
              this.selectedUsers.push(item.id)
            })
          }
        } else if (val == 'DEPT') {
          let arr = JSON.parse(JSON.stringify(this.selectedUsers))
          if (this.selectedUsers && this.selectedUsers.length > 0) {
            this.deptUser.forEach((item) => {
              if (arr.indexOf(item.id) < 0) {
                this.selectedUsersList.push(item)
                this.selectedUsers.push(item.id)
              }
            })
          } else {
            this.deptUser.forEach((item) => {
              this.selectedUsersList.push(item)
              this.selectedUsers.push(item.id)
            })
          }
        } else if (val == 'ADDRESSBOOK') {
          let arr = JSON.parse(JSON.stringify(this.selectedUsers))
          if (this.selectedUsers && this.selectedUsers.length > 0) {
            this.linkman.forEach((item) => {
              if (arr.indexOf(item.id) < 0) {
                this.selectedUsersList.push(item)
                this.selectedUsers.push(item.id)
              }
            })
          } else {
            this.linkman.forEach((item) => {
              this.selectedUsersList.push(item)
              this.selectedUsers.push(item.id)
            })
          }
        }
      }
    },

    /**
     * 点击单选
     */
    // handleRadioChange(ev, value, id) {
    //   console.log(ev, value, id);
    // },

    /**
     * 点击复选框
     */
    handleSelectChange(ev, value, id) {
      if (ev) {
        this.selectedUsersList.push(value)
      } else {
        if (this.selectedUsersList && this.selectedUsersList.length > 0) {
          let list = this.selectedUsersList
          for (let i = 0; i < list.length; i++) {
            if (id == list[i].id) {
              list.splice(i, 1)
            }
          }
        }
      }
    },

    /**
     * 页码值改变
     */
    deptLoadingMore(ev) {
      this.searchData = []
      let appId = 'sOZu9kthmxyP8qQfq0e'
      let pageNum = ev
      const pageSize = 10
      this.loading = true
      this.$api.getDeptUser(appId, this.deptId, pageNum, pageSize, {
        onSucess: (response) => {
          this.loading = false
          let list = response.data.data.datas
          if (this.selectedUsers && this.selectedUsers.length > 0) {
            // 去重
            for (let i = 0; i < this.selectedUsers.length; i++) {
              for (let j = 0; j < list.length; j++) {
                if (this.selectedUsers[i] == list[j].id) {
                  list.splice(j, 1)
                  j--
                }
              }
            }
          }
          this.row_count = response.data.data.rowCount
          this.deptUser = list
          this.title = e.name
          this.deptCount = response.data.data.rowCount
        },
      })
    },

    /**
     * 移除所有已选中用户
     */
    removeAll() {
      this.selectedUsersList = []
    },

    /**
     * 删除单个用户
     */
    closableTag(id, index) {
      console.log(id, index)
    },

    // 通讯录
    /**
     * 通讯录联系人
     */
    contact() {
      const contactsId = 'all'
      let params = {
        pageSize: 10,
        pageNum: 1,
      }
      this.loading = true
      this.$api.getContactUser(contactsId, params, {
        onSucess: (response) => {
          this.loading = false
          if (response.data.errcode == 0) {
            let list = response.data.data.datas
            if (
              that.selectedUsers &&
              that.selectedUsers.length > 0 &&
              list &&
              list.length > 0
            ) {
              for (let i = 0; i < that.selectedUsers.length; i++) {
                for (let j = 0; j < list.length; j++) {
                  if (that.selectedUsers[i] == list[j].id) {
                    list.splice(j, 1)
                    j--
                  }
                }
              }
            }
            this.row_count = response.data.data.rowCount
            this.linkman = list
            if (list.length <= 0) {
              this.isclickEmpty = true
            }
            this.contactCount = response.data.data.rowCount
          }
        },
      })
    },

    // 去重
    deduplication(response) {
      let list = response.data.data.datas
      if (
        this.selectedUsers &&
        this.selectedUsers.length > 0 &&
        list &&
        list.length > 0
      ) {
        for (let i = 0; i < this.selectedUsers.length; i++) {
          for (let j = 0; j < list.length; j++) {
            if (this.selectedUsers[i] == list[j].id) {
              list.splice(j, 1)
              j--
            }
          }
        }
      }
      this.row_count = response.data.data.rowCount
      if (list.length <= 0) {
        this.isclickEmpty = true
      }
      this.contactCount = response.data.data.rowCount
    },
    /**
     * 页码值改变
     */
    contactLoadingMore(num) {},

    getData() {},
  },
  props: {
    userVisible: {
      type: Boolean,
      defaule: false,
    },
    rightSelectedUser: {
      type: Array,
      default: function () {
        return []
      },
    },
  },
}
</script>
<style lang="scss">
//用户选择框弹窗样式
.el-dialog {
  position: relative;
  margin: 0 auto 50px;
  border-radius: 2px;
  -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  // width: 50%;
  border-radius: 6px;
  .el-dialog__header {
    border-top-left-radius: 6px;
    border-top-right-radius: 6px;
    padding: 0 10px 0 10px;
    box-sizing: content-box;
    height: 40px;
    background: linear-gradient(
      270deg,
      rgba(87, 197, 159, 1) 0%,
      rgba(78, 116, 242, 1) 100%
    );
    .el-dialog__title {
      line-height: 40px;
      font-size: 16px;
      color: #ffffff;
    }
    .el-dialog__headerbtn {
      position: absolute;
      top: 10px;
      right: 20px;
      padding: 0;
      background: 0 0;
      border: none;
      outline: 0;
      cursor: pointer;
      font-size: 16px;
      .el-dialog__close {
        color: #fff;
      }
    }
  }
  .el-dialog__body {
    padding: 0;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
  }
  .el-dialog__footer {
    padding: 0 20px 10px 10px;
    text-align: right;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .user-container {
    width: 100%;
    height: 380px;
    .tab-title-list {
      width: 100%;
      height: 40px;
      padding-right: 20px;
      padding-left: 20px;
      box-sizing: border-box;
      display: -webkit-flex;
      display: flex;
      align-items: center;
      justify-content: space-between;
      span {
        display: inline-block;
        height: 22px;
        line-height: 22px;
        padding-left: 8px;
        padding-right: 8px;
        font-size: #5a6779;
        cursor: pointer;
      }
      .tabActive {
        width: 50px;
        height: 22px;
        text-align: center;
        background: rgba(113, 144, 245, 1);
        border-radius: 2px;
        color: #fff;
      }
      .search-box {
        width: 230px;
        height: 40px;
        display: -webkit-flex;
        display: flex;
        align-items: center;
        .el-input__inner {
          -webkit-appearance: none;
          background-color: #fff;
          background-image: none;
          border-radius: 0px;
          border-top-left-radius: 2px;
          border-bottom-left-radius: 2px;
          border: 1px solid #dddddd;
          border-right-color: #4e74f2;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          color: #606266;
          display: inline-block;
          font-size: inherit;
          height: 30px;
          line-height: 30px;
          outline: 0;
          padding: 0 15px;
          -webkit-transition: border-color 0.2s
            cubic-bezier(0.645, 0.045, 0.355, 1);
          transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
          width: 100%;
        }
        .el-input-group__append,
        .el-input-group__prepend {
          background-color: #4e74f2;
          color: #fff;
          vertical-align: middle;
          display: table-cell;
          position: relative;
          border: 0px solid #4e74f2;
          border-radius: 0px;
          border-top-right-radius: 2px;
          border-bottom-right-radius: 2px;
          padding: 0px 13px;
          width: 1px;
          white-space: nowrap;
        }
      }
    }
    .tab-container {
      height: 340px;
      width: 100%;
      padding: 10px 20px 8px 20px;
      box-sizing: border-box;
      .tab-container-box {
        width: 100%;
        height: 100%;
        //按部门和通讯录
        .contact {
          width: 100%;
          height: 310px;
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .left {
            width: 30%;
            margin-right: 15px;
            display: -webkit-flex;
            display: flex;
            flex-direction: column;
            border: 1px solid rgba(242, 242, 242, 1);
            .top-title {
              text-align: center;
              height: 30px;
              line-height: 30px;
              color: #5a6779;
              background: #f2f2f2;
              border-bottom: 1px solid rgba(242, 242, 242, 1);
            }
            .scrollbar {
              height: 288px;
              width: 100%;
              overflow-x: hidden;
              .dept-tree {
                padding-top: 10px;
                height: 100%;
                padding-left: 10px;
                overflow: auto;
              }
            }
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }

            .all-contact {
              height: 30px;
              line-height: 30px;
              padding-left: 10px;
              background: #fafafa;
              border-bottom: 1px solid rgba(242, 242, 242, 1);
              cursor: pointer;
              .icon-img {
                width: 8px;
                height: 10px;
                margin-right: 5px;
              }
            }
          }
        }

        //按角色
        .role {
          width: 100%;
          min-height: 310px;
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .role-left {
            width: 30%;
            height: 310px;
            border: 1px solid rgba(242, 242, 242, 1);
            margin-right: 15px;
            .top-title {
              width: 100%;
              display: inline-block;
              text-align: center;
              height: 30px;
              line-height: 30px;
              color: #5a6779;
              background: #f2f2f2;
              border-bottom: 1px solid rgba(242, 242, 242, 1);
            }
            .scrollbar {
              height: 288px;
              width: 100%;
              overflow-x: hidden;
              display: -webkit-flex;
              display: flex;
              flex-direction: column;
              ul {
                display: -webkit-box;
                display: flex;
                flex-direction: column;
                & > li {
                  height: 40px;
                  line-height: 35px;
                  padding-left: 10px;
                  border-bottom: 1px solid rgba(242, 242, 242, 1);
                  cursor: pointer;
                  .icon-img {
                    width: 8px;
                    height: 10px;
                    margin-right: 5px;
                  }
                }
              }
            }
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
          }
        }

        //最近
        .recent-box {
          width: 100%;
          min-height: 310px;
          display: -webkit-flex;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .left {
            width: 65%;
            height: 310px;
            border: 1px solid rgba(242, 242, 242, 1);
            .top-title {
              width: 100%;
              display: inline-block;
              text-align: center;
              height: 30px;
              line-height: 30px;
              color: #5a6779;
              background: #f2f2f2;
              border-bottom: 1px solid rgba(242, 242, 242, 1);
            }
            .scrollbar {
              height: 280px;
              width: 100%;
              overflow-x: hidden;
              .list-box {
                width: 100%;
                padding: 10px 10px 0 10px;
                box-sizing: border-box;
              }
            }
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
          }
          .center {
            height: 100%;
            line-height: 310px;
            width: 25px;
            text-align: center;
            font-size: 25px;
            color: #ccc;
          }

          .right {
            width: 30%;
            border: 1px solid rgba(242, 242, 242, 1);
            height: 310px;
            overflow: auto;
            .add-all-data {
              padding-left: 10px;
              padding-right: 10px;
              box-sizing: border-box;
              display: -webkit-box;
              display: flex;
              height: 30px;
              align-items: center;
              font-size: 12px;
              justify-content: space-between;
              border-bottom: 1px solid rgba(242, 242, 242, 1);
              span {
                font-size: 12px;
                text-align: center;
                display: inline-block;
                width: 49px;
                height: 22px;
                line-height: 22px;
                background: rgba(255, 255, 255, 1);
                border-radius: 2px;
                background-color: #f56c6c;
                color: #fff;
                cursor: pointer;
              }
            }
            .scrollbar {
              height: 278px;
              width: 100%;
              overflow-x: hidden;
              .tag-lists {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                display: -webkit-box;
                display: flex;
                flex-wrap: wrap;
                // height: calc(100% - 70px);
                .tag {
                  margin-left: 10px;
                  margin-top: 10px;
                }
              }
            }
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
            .group-num {
              width: 100%;
              height: 30px;
              border-top: 1px solid #ccc;
              font-size: 12px;
              display: -webkit-flex;
              justify-content: center;
            }
          }
        }

        //共同样式
        .user-common {
          .role-page {
            width: 34%;
            border: 1px solid rgba(242, 242, 242, 1);
            height: 310px;
            overflow: auto;
            .user-list {
              width: 100%;
              height: calc(100% - 38px);
              overflow: auto;
              white-space: nowrap;
              text-overflow: ellipsis;
              // padding-left: 10px;
              box-sizing: border-box;
              .add-all-data {
                display: -webkit-box;
                display: flex;
                justify-content: center;
                height: 30px;
                align-items: center;
                border-bottom: 1px solid rgba(242, 242, 242, 1);
                span {
                  width: 100px;
                  height: 22px;
                  background: rgba(255, 255, 255, 1);
                  border-radius: 2px;
                  border: 1px solid rgba(221, 221, 221, 1);
                  color: #5a6779;
                  font-size: 12px;
                  display: inline-block;
                  line-height: 21px;
                  text-align: center;
                }
              }
              .current-role {
                text-align: center;
                line-height: 30px;
                height: 30px;
                background: #fafafa;
                border-bottom: 1px solid rgba(242, 242, 242, 1);
              }
              .scrollbar {
                height: 208px;
                width: 100%;
                overflow-x: hidden;
                .list-box {
                  width: 100%;
                  padding: 10px 10px 0 10px;
                  box-sizing: border-box;
                }
              }
              .el-scrollbar__wrap {
                overflow-x: hidden;
              }
            }
            .btn {
              display: inline-block;
              margin-bottom: 0;
              font-weight: normal;
              text-align: center;
              vertical-align: middle;
              -ms-touch-action: manipulation;
              touch-action: manipulation;
              cursor: pointer;
              background-image: none;
              border: 1px solid transparent;
              white-space: nowrap;
              padding: 0;
              font-size: 14px;
              line-height: 1.428571429;
              border-radius: 4px;
              -webkit-user-select: none;
              -moz-user-select: none;
              -ms-user-select: none;
              user-select: none;
              display: -webkit-box;
              display: flex;
              justify-content: center;
              height: 36px;

              align-items: center;

              .el-pagination {
                white-space: nowrap;
                padding: 0;
                color: #303133;
                font-weight: 700;
              }
              .el-pagination button,
              .el-pagination span:not([class*='suffix']) {
                display: inline-block;
                font-size: 12px;
                min-width: 30.5px;
                height: 28px;
                line-height: 28px;
                vertical-align: top;
                -webkit-box-sizing: border-box;
                box-sizing: border-box;
              }
            }
          }
          .selected-role {
            width: 30%;
            border: 1px solid rgba(242, 242, 242, 1);
            height: 310px;
            overflow: auto;
            margin-left: 15px;
            .add-all-data {
              padding-left: 10px;
              padding-right: 10px;
              box-sizing: border-box;
              display: -webkit-box;
              display: flex;
              height: 30px;
              align-items: center;
              font-size: 12px;
              justify-content: space-between;
              border-bottom: 1px solid rgba(242, 242, 242, 1);
              span {
                font-size: 12px;
                text-align: center;
                display: inline-block;
                width: 49px;
                height: 22px;
                line-height: 22px;
                background: rgba(255, 255, 255, 1);
                border-radius: 2px;
                background-color: #f56c6c;
                color: #fff;
                cursor: pointer;
                // border:1px solid rgba(221,221,221,1);
              }
            }
            .scrollbar {
              height: 278px;
              width: 100%;
              overflow-x: hidden;
              .tag-lists {
                box-sizing: border-box;
                width: 100%;
                height: 100%;
                display: -webkit-box;
                display: flex;
                flex-wrap: wrap;
                // height: calc(100% - 70px);
                .tag {
                  margin-left: 10px;
                  margin-top: 10px;
                }
              }
            }
            .el-scrollbar__wrap {
              overflow-x: hidden;
            }
            .group-num {
              width: 100%;
              height: 30px;
              border-top: 1px solid #ccc;
              font-size: 12px;
              display: -webkit-flex;
              justify-content: center;
            }
          }
        }
      }
      .tabBoxBlock {
        display: block;
      }
      .tabBoxNone {
        display: none;
      }
    }
  }
  .dialog-footer {
    display: -webkit-flex;
    display: flex;
    justify-content: flex-end;
    padding-right: 20px;
    padding-bottom: 10px;
  }
}
</style>
